export default __webpack_public_path__ + "static/products-a970aae090b175ccb37dfa4dbc453011.svg";